import { IonPopover } from '@ionic/react';
import styled from 'styled-components';
import { AllieButton } from '../../../../../components';
import { IonPopoverProps } from '../../../../../common/components.types';

export const PopoverAddMotiveStyled: any = styled(IonPopover)<
  IonPopoverProps & { isEdit?: boolean }
>`
  --min-width: ${({ isEdit }) => (isEdit ? '290px' : '222px')};

  ion-item {
    --padding-start: 0;
    --inner-padding-end: 0;
    column-gap: 8px;
  }
`;

export const AllieButtonStyled = styled(AllieButton)`
  --border-width: 1px;
  --border-color: #d6bbfb;
  margin-inline: 0;

  .button-container {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }

  .fill svg path {
    fill: var(--allie-color-primary-60);
  }
`;
